import React, { useState } from 'react';
import httpClient from '../../../services/httpClient'
import { Address } from "../../form"

const NoMatch = ({ lawFirm, accountNumber, sortCode, match, pdfLink, userName, loggedInLawFirmName, matchesPreviousBankDetails }) => {

    const [error, setError] = useState('');

    const statusContainerOutput = {
        backgroundColor: '#f4f4f4',
        borderRadius: 5.7,
    }

    const statusContainer = {
        borderRadius: 5.7,
        backgroundColor: '#f4f4f4',
        borderBottomColor: '#fb5373',
        borderBottomStyle: 'solid',
        borderBottomWidth: 10
    }

    const statusContainerMainHeader = {
        fontSize: 42,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const statusContainerSubHeader = {
        fontSize: 18,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const accountDetailsText = {
        fontSize: '16px',
        fontWeight: '300',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#000'
    }

    const previousAccountDetailsMatchingText = {
        paddingTop: '25px',
        paddingBottom: '25px',
        marginBottom: '30px',
        border: '2px solid #fdb4c2',
        borderRadius: '10px',
        color: 'black',
        fontFamily: 'Calibri, Lucida Sans, Geneva, Verdana, sans-serif',
        fontSize: '18px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center'
    }

    const handleDownloadPdfCopy = async (event) => {
        let response = null;
        try {
            httpClient.defaults.headers.common['Username'] = userName;
            httpClient.defaults.headers.common["Account-Number"] = accountNumber;
            httpClient.defaults.headers.common["Sort-Code"] = sortCode;
            httpClient.defaults.headers.common["Users-Law-Firm"] = loggedInLawFirmName;
            httpClient.defaults.headers.common["Users-Law-Firm-Reference"] = "";
            response = await httpClient.get(pdfLink, { responseType: 'blob' });
            const url = window.URL.createObjectURL(response, { type: 'application/pdf' });
            let a = document.createElement('a');
            a.href = url;
            a.download = "outcome.pdf";
            a.click();
            a.remove();
        } catch (e) {
            if (e.response.status === 404) {
                //404 status code means transient Id from the original search has expired. We want to display a specific message for this error scenario
                setError('Your Session has timed out. You will need to start a new search');
            }
            else {
                setError('Unfortunately we were unable to retrieve your PDF Summary at this time. If you require further assistance, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    return (
        <div data-testid="no-match-component">
            {match === 'No Match' ? (
                <div data-testid="no-match-component-not-matched">
                    <div style={statusContainer} className="mt-2 p-5">
                        <div className="row">
                            <div className="col-1">
                                <img height="75px" src="data:image/png;base64, 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" alt="Confirmly Matched Icon" />
                            </div>
                            <div className="col-9">
                                <span style={statusContainerMainHeader} className="ml-3" id="itsStatus">
                                    No match
                                </span>
                                <p style={statusContainerSubHeader} className="mt-1 ml-3" id="itsUnderReview">
                                    The law firm is known to us but the details don't match.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div style={accountDetailsText} className="row mt-3 mb-3">
                        <div className="col-10 text-danger">
                            {error}
                        </div>
                    </div>

                    <div style={accountDetailsText} className="row">
                        <div className="col-10">
                            The account details you provided DO NOT match the ones we hold for the firm.
                        </div>
                        <div className="col-2">
                            <button className="fs-6 btn btn-dark" onClick={handleDownloadPdfCopy} id="pdfButton"> <i className="fa-solid fa-file-arrow-down"></i>&nbsp;&nbsp;&nbsp;DOWNLOAD PDF </button>
                        </div>
                    </div>
                    <div style={accountDetailsText} className="row mb-5">
                        <div className="col-12">
                            For a full summary download the pdf.
                        </div>
                    </div>


                    {matchesPreviousBankDetails ? (

                        <div style={previousAccountDetailsMatchingText}>
                            The law firm is known to us but the details provided are outdated.
                        </div>

                    ) : (null)}

                    {
                        /* 
                            JAS-7677 - COMMENTED UNTIL: JAS-7601
                            <div style={accountDetailsText} className="row mt-4 mb-5">
                                <div className="col-12 fw_bold text-decoration-underline">
                                    Does this mean it's safe to send the money?
                                </div>
                            </div> 
                        */
                    }
                    <div style={statusContainerOutput} className="p-5">
                        <div className="row">
                            <div className="col-1">
                                <img src="data:image/png;base64, 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" alt="Confirmly Matched Icon" />
                            </div>
                            <div className="col-9 mt-4">
                                <span className="fs-2">YOU ASKED US TO CHECK THESE DETAILS</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Company name
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.companyName}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Address
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                <Address lawFirm={lawFirm} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Regulation Registration Number for LMS Main Office
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.regulationRegistrationNumber ? (lawFirm?.regulationRegistrationNumber) : ('Not Supplied')}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Sort code
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {sortCode}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Account number
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {accountNumber}
                            </div>
                        </div>

                    </div>

                </div>
            ) : (null)}
        </div>
    );
}

export default NoMatch;